import React from 'react';
import { Checkbox } from '../ui/checkbox';

// S1: steht ÜBER den Codefeldern - CodeFelder schickt beim 6. Zeichen automatisch ab.
export const GeraetMerken = ({ merken, onChange }) => (
  <div className="flex items-start gap-2.5 rounded-md bg-slate-50 p-3">
    <Checkbox id="geraet-merken" checked={merken} onCheckedChange={(v) => onChange(v === true)} className="mt-0.5" data-testid="geraet-merken" />
    <label htmlFor="geraet-merken" className="cursor-pointer">
      <span className="block text-sm font-medium text-slate-900">Dieses Gerät 30 Tage merken</span>
      <span className="block text-xs text-slate-500">Dann fragen wir hier 30 Tage lang nicht nach dem Code. Nicht an fremden oder gemeinsam genutzten Geräten.</span>
    </label>
  </div>
);

export default GeraetMerken;
